module.exports = __webpack_public_path__ + "img/uk-dining-3.4cc93a22.png";